module.exports = __webpack_public_path__ + "static/steph-c70253d03d058bbd29cedc28fc3527cf.jpg";